import * as Sentry from '@sentry/browser';

window.Sentry = Sentry;

const whitelistUrls = new Set([STATIC_URL_BASE, MAIN_URL]);
if (window.WHITE_CONF && window.WHITE_CONF.host) {
  whitelistUrls.add(`https://${window.WHITE_CONF.host}`);
}

class ProxyTransport extends Sentry.Transports.FetchTransport {
  sendEvent(event) {
    const proxiedURL = this.url.replace(
      'https://sentry.io/api',
      SENTRY_PROXY_URL,
    );
    this.url = proxiedURL;
    return super.sendEvent(event);
  }
}

Sentry.init({
  dsn: SENTRY_DSN,
  debug: ENV_NAME === 'staging' || ENV_NAME === 'dev',
  environment: ENV_NAME,
  release: RELEASE_ID,
  attachStacktrace: true,
  whitelistUrls: MODE === 'development' ? null : Array.from(whitelistUrls),
  autoBreadcrumbs: {
    xhr: true, // XMLHttpRequest
    console: false, // console logging
    dom: true, // DOM interactions, i.e. clicks/typing
    location: true, // url changes, including pushState/popState
    sentry: true, // sentry events
  },
  transport: SENTRY_PROXY_URL ? ProxyTransport : null,
  integrations(integrations) {
    const integrationsWithoutBreadcrumbs = integrations.filter(
      integration => integration.name !== 'Breadcrumbs',
    );
    return [
      ...integrationsWithoutBreadcrumbs,
      new Sentry.Integrations.Breadcrumbs({
        xhr: true, // XMLHttpRequest
        console: false, // console logging
        dom: true, // DOM interactions, i.e. clicks/typing
        location: true, // url changes, including pushState/popState
        sentry: true, // sentry events
      }),
    ];
  },
});
